export default __webpack_public_path__ + "static/media/udemy2.c6e2990b.svg";